jQuery(function ($) {
  "use strict";

  // Hamburger menu open/close
  var $header = $(".js-header");

  function closeMenu() {
    $(".js-hamburger").attr("aria-expanded", "false").removeClass("is-active");
    $header.removeClass("is-nav-open");
    $("body").removeClass("is-nav-locked");
  }

  $(".js-hamburger").on("click", function () {
    var $btn = $(this);
    var willOpen = $btn.attr("aria-expanded") !== "true";
    $btn.attr("aria-expanded", String(willOpen));
    $btn.toggleClass("is-active", willOpen);
    $header.toggleClass("is-nav-open", willOpen);
    $("body").toggleClass("is-nav-locked", willOpen);
  });

  // Close menu on anchor click inside the nav
  $(".header__nav a[href^='#']").on("click", function () {
    closeMenu();
  });

  // Smooth scroll for in-page anchors
  $('a[href^="#"]').on("click", function () {
    var href = $(this).attr("href");
    if (href === "#" || href === "") return;

    // pageTop button always scrolls to the top.
    // The header is sticky/fixed, which makes jQuery .offset().top unreliable
    // for a normal anchor calculation, so handle it separately.
    if ($(this).hasClass("contact__pageTop")) {
      $("html, body").animate({ scrollTop: 0 }, 400);
      return false;
    }

    var $target = $(href);
    if ($target.length) {
      // SP header is transparent (hamburger only), so no offset needed.
      // PC header is sticky and always visible, so subtract its height.
      var isSP = window.matchMedia("(max-width: 767px)").matches;
      var headerH = isSP ? 0 : ($(".header").outerHeight() || 0);
      $("html, body").animate(
        { scrollTop: $target.offset().top - headerH },
        400
      );
      return false;
    }
  });
});
